<p-card header="Bitte wählen Sie eine Klasse aus">
    <app-school-class-list [schoolClasses]="schoolClasses" baseUrl="/enaio-certificates/covid-tests/class" [isHalfYear]="isHalfYear"></app-school-class-list>
</p-card>
